/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    errorLog: {
        optionsExclusive: {
            and: "and option",
            option: "Option:",
            warning: "are exclusives and can't be used together"
        },
        rangeInvalid: {
            incorrectValue: "Value of range given is invalid"
        },
        timeInvalid: {
            incorrectValue: "Value of time of timePicker is invalid",
            notCorrect: "isn't valid"
        }
    },
    labels: {
        days: "D",
        hours: "Hours",
        minutes: "Minutes"
    }
};